import React               from "react"
import {useTranslation}    from "react-i18next"

import ItemNotFound   from "../common/Items/ItemNotFound"
import IconDataSource from "../common/Icons/DataSource";

const NotFound: React.FC = () => {

    const { t } = useTranslation()

    const link: string = '/person-groups'

    return (
        <ItemNotFound icon={<IconDataSource link={link} size="large" />}
                      link={link}
                      subTitle={t('common.item_not_found', {
                          itemType: t('data-sources.title_item').toLowerCase() }
                      )} />
    )
}

export default NotFound